/**
 * menus/index.js — 진입점
 *
 * 사용법:
 *   import { getVisibleMenus, getVisibleSitemaps } from '.../menus/index.js';
 *   getVisibleMenus('type_1')   // type_1 GNB
 *   getVisibleMenus('type_2')   // type_2 GNB
 *   getVisibleSitemaps('type_3') // type_3 햄버거메뉴
 *
 * 새 테마 추가 시:
 *   1. menus/type_N.js 생성
 *   2. 아래 SITEMAP_MAP / MENU_MAP 에 'type_N' 키 추가
 *
 * type_4 는 API 기반 메뉴(data.menu_items)를 사용하므로
 * Header.vue 에서 type_4/HeaderMenu.vue 를 직접 렌더합니다.
 */

export * from './base.js';

import { SITEMAPS as SITEMAPS_TYPE1, MENUS as MENUS_TYPE1 } from './type_1.js';
import { SITEMAPS as SITEMAPS_TYPE2, MENUS as MENUS_TYPE2 } from './type_2.js';
import { SITEMAPS as SITEMAPS_TYPE3, MENUS as MENUS_TYPE3 } from './type_3.js';
import { SITEMAPS as SITEMAPS_TYPE4, MENUS as MENUS_TYPE4 } from './type_4.js';
import { SITEMAPS as SITEMAPS_TYPE5, MENUS as MENUS_TYPE5 } from './type_5.js';
import { SITEMAPS as SITEMAPS_TYPE6, MENUS as MENUS_TYPE6 } from './type_6.js';
import { SITEMAPS as SITEMAPS_TYPE7, MENUS as MENUS_TYPE7 } from './type_7.js';

import { isVisible } from './base.js';

const SITEMAP_MAP = {
    type_1: SITEMAPS_TYPE1,
    type_2: SITEMAPS_TYPE2,
    type_3: SITEMAPS_TYPE3,
    type_4: SITEMAPS_TYPE4,
    type_5: SITEMAPS_TYPE5,
    type_6: SITEMAPS_TYPE6,
    type_7: SITEMAPS_TYPE7,
};

const MENU_MAP = {
    type_1: MENUS_TYPE1,
    type_2: MENUS_TYPE2,
    type_3: MENUS_TYPE3,
    type_4: MENUS_TYPE4,
    type_5: MENUS_TYPE5,
    type_6: MENUS_TYPE6,
    type_7: MENUS_TYPE7,
};

/**
 * @param {string} [themeType='type_1']
 * @returns {object[]}
 */
export function getVisibleSitemaps(themeType = 'type_1') {
    const sitemaps = SITEMAP_MAP[themeType] || SITEMAPS_TYPE1;
    return sitemaps
        .filter((entry) => isVisible(entry.SECTION.VISIBLE))
        .map((entry) => ({
            ...entry,
            GROUPS: entry.GROUPS.filter((g) => isVisible(g.GROUP.VISIBLE)).map((g) => ({
                ...g,
                TABS: g.TABS.map((tab) => ({
                    ...tab,
                    ITEMS: tab.ITEMS.filter((item) => isVisible(item.VISIBLE)),
                })),
            })),
        }));
}

/**
 * @param {string} [themeType='type_1']
 * @returns {object[]}
 */
export function getVisibleMenus(themeType = 'type_1') {
    const menus = MENU_MAP[themeType] || MENUS_TYPE1;
    return menus
        .filter((entry) => isVisible(entry.GROUP.VISIBLE))
        .map((entry) => ({
            ...entry,
            SECTIONS: entry.SECTIONS.filter((s) => isVisible(s.SECTION.VISIBLE)).map((s) => ({
                ...s,
                TABS: s.TABS.map((tab) => ({
                    ...tab,
                    ITEMS: tab.ITEMS.filter((item) => isVisible(item.VISIBLE)),
                })),
            })),
        }));
}
